import React, { useRef, useState, useEffect, useCallback } from "react";
import Webcam from "react-webcam";
import { analyzeWaste } from "./ai";
import "./app-scan.css";
import iconCam from "../../../upload/cam-icon.png";

export default function CameraCapture({ onComplete }) {
  const webcamRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [facingMode, setFacingMode] = useState("environment");

  const videoConstraints = {
    facingMode,
    width: { ideal: 1280 },
    height: { ideal: 720 },
  };

  // Bắt đầu đếm ngược khi nhấn "Chụp"
  const capture = () => {
    setCountdown(3);
    let sec = 3;
    const timer = setInterval(() => {
      sec--;
      setCountdown(sec);
      if (sec <= 0) {
        clearInterval(timer);
        takePhoto();
      }
    }, 1000);
  };

  const takePhoto = async () => {
    setLoading(true);
    const imageSrc = webcamRef.current.getScreenshot();
    if (!imageSrc) {
      setLoading(false);
      alert("Không thể chụp được ảnh. Vui lòng thử lại.");
      return;
    }

    const base64 = imageSrc.split(",")[1];
    try {
      const analysis = await analyzeWaste(base64);
      onComplete({
        result: analysis,
        capturedImage: imageSrc,
      });
    } catch (err) {
      onComplete({ error: err.message, capturedImage: imageSrc });
    } finally {
      setLoading(false);
      setCountdown(0);
    }
  };

  const switchCamera = useCallback(() => {
    setFacingMode((prev) => (prev === "user" ? "environment" : "user"));
  }, []);

  return (
    <div className="scan-app-container camera-centered">
      <div className={`camera-wrap ${loading ? "loading" : ""}`}>
        <Webcam
          key={facingMode}
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          videoConstraints={videoConstraints}
          mirrored={false}
          className="camera-video"
        />

        <div className="inner-corners">
          <span className="corner top-left"></span>
          <span className="corner top-right"></span>
          <span className="corner bottom-left"></span>
          <span className="corner bottom-right"></span>
        </div>

        {loading && (
          <div className="scan-animation">
            <div className="camera-icon-wrapper">
              <div className="rotating-ring"></div>
              <img src={iconCam} width="30" height="30" alt="Camera Icon" className="camera-icon-static" />
            </div>
            <div className="scan-line" />
          </div>
        )}

        {countdown > 0 && <div className="countdown-display">{countdown}</div>}

        {!loading && countdown === 0 && (
          <div className="camera-overlay">
            <div className="controls">
              <button className="capture-btn" onClick={capture}>
                Chụp
              </button>
              {/* <button className="switch-btn" onClick={switchCamera}>
                Đổi Camera
              </button> */}
            </div>
          </div>
        )}
      </div>

      {!loading && countdown === 0 && (
        <>
          <div className="text-in-cam t-h3">Hãy đặt rác trước camera</div>
          <div className="text-in-cam">Nhấn "Chụp" để bắt đầu quét</div>
        </>
      )}

      {loading && (
        <>
          <div className="loading-indicator text-in-cam t-h3">Đang quét...</div>
          <div className="text-in-cam">Đang nhận diện vật phẩm...</div>
        </>
      )}
    </div>
  );
}
